import React from "react";

var CheckCircleIcon = function CheckCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.485 3.515c-4.686-4.686-12.284-4.686-16.971 0-4.686 4.687-4.686 12.284 0 16.971 4.686 4.686 12.284 4.686 16.971 0s4.687-12.285 0-16.971zm-2.726 5.136l-6.61 7.711L6.4 12.8a1 1 0 0 1 1.2-1.6l3.25 2.438 5.39-6.289c.36-.418.992-.467 1.41-.108.42.359.469.991.109 1.41z"
  }));
};

CheckCircleIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
CheckCircleIcon.defaultProps.solid = true;
export default CheckCircleIcon;